module.exports = __webpack_public_path__ + "img/0f04c44.svg";